
import {defineComponent} from 'vue';
import {userResetPwURL} from "@/config/app-settings";
import axios from "axios";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Card from "primevue/card";
import Message from "primevue/message";

export default defineComponent({
  name: 'ResetPw',
  components: {Card, InputText, Button, Message},
  data() {
    return {
      state: 'default' as 'default' | 'success' | 'error',
      email: '' as string
    }
  },
  computed: {
    mailValid(): boolean {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return this.email.length !== 0 && re.test(String(this.email).toLowerCase());
    }
  },
  methods: {
    resetPw: function () {
      axios.post(userResetPwURL, {email: this.email})
          .then(() => {
            this.state = 'success'

          }).catch(() => this.state = 'error')
    },
    toLogin() {
      this.$emit('login')
      this.$router.push({name: 'Login'});
    },
    toResetPwResetToken() {
      this.$emit('resetPwResetToken')
      this.$router.push({ name: 'ResetPwResetToken'})
    }
  }
});
